import ShopType from "@/enum/ShopType";
import mainServerClient from "@/services/http/mainServerClient";
import { get, post } from "@/services/http/platformServer";
import { WrapperList } from "@/utils/utilityTypes";

export interface BuyerBlackList {
    id: number;
    shopType: ShopType;
    buyerUsername?: string;
    buyerNickname?: string;
    operateUsername: string;
    reason?: string;
    created: string;
    shopId: number;
}

interface QueryBuyerBlacklistParams {
    shopType?: ShopType;
    buyerNickname?: string;
    createdStart?: string;
    createdEnd?: string;
    pageNo: number;
    pageSize: number;
}

export function queryBuyerBlacklist(params: QueryBuyerBlacklistParams): Promise<WrapperList<BuyerBlackList>> {
    return mainServerClient.post("/buyer_blacklist/query", params);
}

export interface CompanySetting {
    companyId: number;
    buyerBlacklistOrderLockEnabled: boolean;
    buyerBlacklistOrderLockEnabledTime: string;
}

export function getBuyerBlacklistSetting(): Promise<CompanySetting> {
    return mainServerClient.get("/buyer_blacklist/setting/get");
}

export function enableBuyerBlacklistSetting(): Promise<void> {
    return mainServerClient.post("/buyer_blacklist/setting/enable");
}

export function disableBuyerBlacklistSetting(): Promise<void> {
    return mainServerClient.post("/buyer_blacklist/setting/disable");
}

export function batchDeleteBuyerBlacklist(ids: number[]): Promise<void> {
    return mainServerClient.post("/buyer_blacklist/batch_delete", { ids });
}

interface AddBuyerBlacklistParams {
    shopId: number;
    buyerUsername: string;
    buyerNickname: string;
    operateUsername: string;
    reason: string;
}

export function addBuyerBlacklist(params: AddBuyerBlacklistParams): Promise<void> {
    return post(params.shopId, "/order/buyer_blacklist/add", params);
}

export function deleteBuyerBlacklist(shopId: number, orderId: number): Promise<void> {
    return post(shopId, "/order/buyer_blacklist/delete", { shopId, orderId });
}
